import { Button, CircularProgress, Checkbox, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import Chart from "react-google-charts";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { jsPDF } from "jspdf";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';

import { useAppSelector } from '../app/hooks';
import { getProjectDetails, getFanDetails, getFanData, getFetching, getFetchingError, createNewProject, getDrafts, getProjects, getGADetails } from '../app/reducer/project.reducer';
import { ENCON_LOGO } from '../assets';
import Page1 from './datasheet/Page1';
import Page2 from './datasheet/Page2';
import Page3 from './datasheet/Page3';
import Page4 from './datasheet/Page4';
import Page5 from './datasheet/Page5';

import AlertComponent from "./general/Alert";
import { getUser } from '../app/reducer/auth.reducer';

const domtoimage = require('dom-to-image');
// const MyDocument = () => (
//   <Document>
//     <Page size="A4">
//       <Page1 />
//     </Page>
//   </Document>
// );

export default function Datasheet({...props}:any) {
  
  const dispatch = useDispatch();
  const history = useHistory();


  const [openErrAlert, setOpenErrAlert] = React.useState<boolean>(false);

  const [showPage1, setShowPage1] = React.useState<boolean>(true);
  const [showPage2, setShowPage2] = React.useState<boolean>(true);
  const [showPage3, setShowPage3] = React.useState<boolean>(true);
  const [showPage4, setShowPage4] = React.useState<boolean>(true);
  const [showPage5, setShowPage5] = React.useState<boolean>(true);

  const projectDetails = useAppSelector(getProjectDetails)||{};
  console.log(projectDetails)
  const fanDetails = useAppSelector(getFanDetails);
  const gaDetails = useAppSelector(getGADetails);
  const fan = useAppSelector(getFanData);
  const projBusy = useAppSelector(getFetching);
  const fetchingErr = useAppSelector(getFetchingError);
  const user = useAppSelector(getUser);

  const [exportBusy, setExportBusy] = React.useState<boolean>(false);

  const printRef1 = React.useRef();
  const printRef2 = React.useRef();
  const printRef3 = React.useRef();
  const printRef4 = React.useRef();
  const printRef5 = React.useRef();

  const saveProject = async () => {


    let data = {...projectDetails, fan_form: fanDetails, fan_details: fan};
    if(gaDetails){
      data.ga_details = gaDetails;
    };
    await dispatch(createNewProject(data))
    // if(fetchingErr===false){
      dispatch(getDrafts());
      dispatch(getProjects());
      history.push('/projects');
    // }else{
    //   setOpenErrAlert(true);
    // }

  }

  const exportPDF = async () => {
    setExportBusy(true);

    var pdf = new jsPDF("p", "mm", "a4");

    var pageWidth = pdf.internal.pageSize.getWidth();
    var pageHeight = pdf.internal.pageSize.getHeight();

    // var imageResHeight = pageHeight*10;
    // var imageResWidth = pageWidth*10

    const page1 = document.getElementById("datasheet-page1");
    const page2 = document.getElementById("datasheet-page2");
    const page3 = document.getElementById("datasheet-page3");
    const page4 = document.getElementById("datasheet-page4");
    const page5 = document.getElementById("datasheet-page5");

    if(showPage1 && page1){

      // page1.scrollIntoView();

      var imageResHeight = page1.offsetHeight;
      var imageResWidth = page1.offsetWidth;
  
      const canvasOptions = { 
        scale: 1, // use the desired scale
        allowTaint: true,
        useCORS: true,
        width: imageResWidth+10,
        height: imageResHeight+10
      }

      await toJpeg(page1)
      .then(async function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        // page1.appendChild(img);
        const sizeBytes = dataUrl.length * 0.75; // base64 → bytes
        const sizeKB = (sizeBytes / (1024*1024)).toFixed(2);
        console.log("Page 1 size:", sizeKB, "MB");
        await pdf.addImage(dataUrl,"PNG", 0, 0, pageWidth, pageHeight);
        // pdf.save('sample-file.pdf');
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });

    }
    
    if(showPage2 && page2){
      pdf.addPage();

      // page1.scrollIntoView();

      var imageResHeight = page2.offsetHeight;
      var imageResWidth = page2.offsetWidth;
  
      const canvasOptions = { 
        scale: 1, // use the desired scale
        allowTaint: true,
        useCORS: true,
        width: imageResWidth+10,
        height: imageResHeight+10
      }

      await toJpeg(page2)
      .then(async function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        // page2.appendChild(img);
         const sizeBytes = dataUrl.length * 0.75; // base64 → bytes
        const sizeKB = (sizeBytes / (1024*1024)).toFixed(2);
        console.log("Page 2 size:", sizeKB, "MB");
        await pdf.addImage(dataUrl,"PNG", 0, 0, pageWidth, pageHeight);
        // pdf.save('sample-file.pdf');
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
    }

    if(showPage3 && page3){
      pdf.addPage();

      // page1.scrollIntoView();

      var imageResHeight = page3.offsetHeight;
      var imageResWidth = page3.offsetWidth;
  
      const canvasOptions = { 
        scale: 1, // use the desired scale
        allowTaint: true,
        useCORS: true,
        width: imageResWidth+10,
        height: imageResHeight+10
      }

      await toJpeg(page3)
      .then(async function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        // page3.appendChild(img);
         const sizeBytes = dataUrl.length * 0.75; // base64 → bytes
        const sizeKB = (sizeBytes / (1024*1024)).toFixed(2);
        console.log("Page 3 size:", sizeKB, "MB");
        await pdf.addImage(dataUrl,"PNG", 0, 0, pageWidth, pageHeight);
        // pdf.save('sample-file.pdf');
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
    }

    if(showPage4 && page4){
      pdf.addPage();


      // page4.scrollIntoView();

      var imageResHeight = page4.offsetHeight;
      var imageResWidth = page4.offsetWidth;
  
      const canvasOptions = { 
        scale: 1, // use the desired scale
        allowTaint: true,
        useCORS: true,
        width: imageResWidth+10,
        height: imageResHeight+10
      }

      await toJpeg(page4)
      .then(async function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        // papage4ge1.appendChild(img);
         const sizeBytes = dataUrl.length * 0.75; // base64 → bytes
        const sizeKB = (sizeBytes / (1024*1024)).toFixed(2);
        console.log("Page 4 size:", sizeKB, "MB");
        await pdf.addImage(dataUrl,"PNG", 0, 0, pageWidth, pageHeight);
        // pdf.save('sample-file.pdf');
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
    }

    if(gaDetails && showPage5 && page5){
      pdf.addPage();


      // page5.scrollIntoView();

      var imageResHeight = page5.offsetHeight;
      var imageResWidth = page5.offsetWidth;
      console.log(imageResHeight,imageResWidth);
      const canvasOptions = { 
        scale: 1, // use the desired scale
        allowTaint: true,
        useCORS: true,
        width: imageResWidth+10,
        height: imageResHeight+10
      }
      console.log(page5)
      await toJpeg(page5)
      .then(async function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        console.log(dataUrl);
        // page5.appendChild(img);
         const sizeBytes = dataUrl.length * 0.75; // base64 → bytes
        const sizeKB = (sizeBytes / (1024*1024)).toFixed(2);
        console.log("Page 5 size:", sizeKB, "MB");
        await pdf.addImage(dataUrl,"PNG", 0, 0, pageWidth, pageHeight);
        // pdf.save('sample-file.pdf');
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
    }

    pdf.save(`encon-datasheet-${projectDetails.project_number}.pdf`);
    setExportBusy(false);
  }
  
  return (
    <div style={{
      display:'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
      padding: '50px'
    }}>
      <Typography variant="h5" gutterBottom>
        <b>Datasheet</b>
      </Typography>
      <br/>
      <div  style={{display:'flex', flexDirection:'row'}}>
        <div style={{margin:'10px', padding:'10px', borderRadius:'5px', backgroundColor:'#ddd'}}>
          Show Page 1:
          <Checkbox
          checked={showPage1}
          disabled/>
        </div>
        <div style={{margin:'10px', padding:'10px', borderRadius:'5px', backgroundColor:'#ddd'}}>
          Show Page 2:
          <Checkbox
          checked={showPage2}
          onChange={
            (e)=>{
              setShowPage2(e.target.checked)
            }
          }/>
        </div>
        <div style={{margin:'10px', padding:'10px', borderRadius:'5px', backgroundColor:'#ddd'}}>
          Show Page 3:
          <Checkbox
          checked={showPage3}
          onChange={
            (e)=>{
              setShowPage3(e.target.checked)
            }
          }/>
        </div>
        <div style={{margin:'10px', padding:'10px', borderRadius:'5px', backgroundColor:'#ddd'}}>
          Show Page 4:
          <Checkbox
          checked={showPage4}
          onChange={
            (e)=>{
              setShowPage4(e.target.checked)
            }
          }/>
        </div>
        <div style={{margin:'10px', padding:'10px', borderRadius:'5px', backgroundColor:'#ddd'}}>
          Show Page 5:
          <Checkbox
          checked={showPage5}
          onChange={
            (e)=>{
              setShowPage5(e.target.checked)
            }
          }/>
        </div>
      </div>
      <br/>
      <br/>
      <div style={{width:'100%', padding: '20px', borderRadius:'10px', backgroundColor: '#ddd'}}>
        {showPage1 && <Page1/>}
      <br/>
        {showPage2 && <Page2/>}
      <br/>
        {showPage3 && <Page3/>}
      <br/>
        {showPage4 && <Page4/>}
      <br/>
      {
        gaDetails?
        (showPage5 && <Page5/>)
        :
        (user.user?.userType==1&&
        (<Button
          variant="contained"
          color="primary"
          size="large"
          style={{marginLeft:'20px'}}
          onClick={e=>props.setIndex(6)}
        >
            Set GA Drawing Values for Page 5
        </Button>))
      }
       {/* <br/>
      <Page3 />
      <br/>
      <Page4 />
      <br/>
      <Page5 /> */}
      <br/>
      </div>
      <br/>
      <div
      style={{
        display:'flex',
        flexDirection:'row',
        justifyContent:'flex-start'
      }}>
        <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={()=>saveProject()}
                style={{marginLeft:'20px'}}
                disabled={projBusy}
        >
            {projBusy?
            <CircularProgress 
            size={26}
            />:"Save Project"}
        </Button>
        <Button
            variant="outlined"
            color="primary"
            size="large"
            style={{marginLeft:'20px',backgroundColor:'#EF4444'}}
            onClick={e=>props.setIndex(6)}
        >
            Back
        </Button>
        <Button
            variant="contained"
            color="primary"
            size="large"
            style={{marginLeft:'20px'}}
            disabled={exportBusy}
            onClick={()=>exportPDF()}
        >
        {exportBusy?
        <CircularProgress 
        size={26}
        />:"Export"}
          </Button>
      </div>
        <AlertComponent open={openErrAlert} message="Something went wrong. Please Try again." severity="error" handleClose={()=>{setOpenErrAlert(false)}} />
    </div>
  );
}
